import { memo } from "react";

import { Text } from "@components/Text";
import { tw } from "classnames";

const styles = {
  base: tw("pb-16"),
};

const CollectionGridEmptyBase = ({
  emptyStateText,
}: {
  emptyStateText: string;
}) => (
  <div className={styles.base}>
    <Text as="body0">{emptyStateText}</Text>
  </div>
);

export const CollectionGridEmpty = memo(CollectionGridEmptyBase);
